import { useColorModeValue } from '@chakra-ui/react';

import getDefaultTransitionProps from 'theme/utils/getDefaultTransitionProps';

type Props = {
  isExpanded?: boolean;
  isCollapsed?: boolean;
  isActive?: boolean;
};

export default function useNavLinkProps({ isExpanded, isCollapsed, isActive }: Props) {
  const textColor = useColorModeValue('#2A2A2E', '#EFEFEF');
  const activeBgColor = useColorModeValue('#F5F5F5', '#212121');

  return {
    itemProps: {
      py: '9px',
      height: '48px',
      display: 'flex',
      color: textColor,
      bgColor: isActive ? activeBgColor : 'transparent',
      _hover: {
        color: textColor,
        bgColor: activeBgColor,
      },
      borderRadius: '8px',
      ...getDefaultTransitionProps({ transitionProperty: 'width, padding' }),
    },
    textProps: {
      variant: 'inherit',
      fontSize: '14px',
      lineHeight: '16px',
      fontWeight: 400,
      fontFamily: '\'HarmonyOS Sans SC\', var(--chakra-fonts-body)',
      opacity: { base: '1', lg: isExpanded ? '1' : '0', xl: isCollapsed ? '0' : '1' },
      transitionProperty: 'opacity',
      transitionDuration: 'normal',
      transitionTimingFunction: 'ease',
    },
  };
}
